import { render, staticRenderFns } from "./ColaboradoresInstitucional.vue?vue&type=template&id=6b2f1f51&"
import script from "./ColaboradoresInstitucional.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports